<template>
  <v-container fluid>
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field id="titulo" v-model="titulo" class="my-0" label="Título" outlined :error-messages="errors" />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-textarea
            id="obras"
            v-model="obras"
            class="mt-0 pt-0"
            label="Obras"
            placeholder="Insira os códigos das obras, um por linha. Ex.:

CI1944457111
CI1944457348"
            rows="5"
            no-resize
            clearable
            clear-icon="mdi-close-circle"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12">
        <v-tooltip bottom :disabled="saneamentoVoc === null ? true : false">
          <template v-slot:activator="{ on, attrs }">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field
                v-bind="attrs"
                :value="saneamentoVoc ? saneamentoVoc.nome : ''"
                label="Saneamento do VOC"
                placeholder="Selecione um cálculo"
                outlined
                readonly
                :error-messages="errors"
                v-on="on"
                @focus="dialogSeletorSaneamentoVoc = true"
              />
            </validation-provider>
          </template>
          <span>{{ saneamentoVoc ? saneamentoVoc.nome : '' }}</span>
        </v-tooltip>
        <dialog-seletor-saneamento-voc :activated.sync="dialogSeletorSaneamentoVoc" @selected="selecionaSaneamentoVoc" />
      </v-col>
    </v-row>

    <v-row id="data-imobilizacao" class="mt-n3 mx-auto">
      <v-col class="pt-0" xl="5" lg="5" md="5" sm="5" cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <date-picker
            v-model="dataImobilizacaoInicio"
            label="Data Imobilização"
            type="date"
            :rules="`date_precisa_ser_menor_ou_igual_a:${dataImobilizacaoFim}`"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col xl="2" lg="2" md="2" sm="2" cols="12" class="text-center" style="min-width: 60px !important; padding-top: 32px">
        <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
      </v-col>
      <v-col class="pt-0" xl="5" lg="5" md="5" sm="5" cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <date-picker
            v-model="dataImobilizacaoFim"
            label="Data Imobilização"
            type="date"
            :rules="`date_precisa_ser_maior_ou_igual_a:${dataImobilizacaoInicio}`"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      DatePicker: () => import('@/components/general/DatePicker'),
      DialogSeletorSaneamentoVoc: () => import('@/components/general/selectors/GeneralCalculosComCaSelector')
    },

    data: () => ({
      dialogSeletorSaneamentoVoc: false
    }),

    computed: {
      titulo: {
        get() {
          return this.$store.state.indicadorPrazos.titulo;
        },
        set(value) {
          this.$store.dispatch('setIndicadorPrazos', { titulo: value });
        }
      },
      obras: {
        get() {
          return this.$store.state.indicadorPrazos.obras;
        },
        set(value) {
          this.$store.dispatch('setIndicadorPrazos', { obras: value });
        }
      },
      saneamentoVoc: {
        get() {
          return this.$store.state.indicadorPrazos.saneamentoVoc;
        },
        set(value) {
          this.$store.dispatch('setIndicadorPrazos', { saneamentoVoc: value });
        }
      },
      dataImobilizacaoInicio: {
        get() {
          return this.$store.state.indicadorPrazos.dataImobilizacaoInicio;
        },
        set(value) {
          this.$store.dispatch('setIndicadorPrazos', {
            dataImobilizacaoInicio: value
          });
        }
      },
      dataImobilizacaoFim: {
        get() {
          return this.$store.state.indicadorPrazos.dataImobilizacaoFim;
        },
        set(value) {
          this.$store.dispatch('setIndicadorPrazos', {
            dataImobilizacaoFim: value
          });
        }
      }
    },

    methods: {
      selecionaSaneamentoVoc(data) {
        this.saneamentoVoc = {
          id: data.id,
          nome: data.nome
        };
        this.dialogSeletorSaneamentoVoc = false;
      },

      exportData() {
        const vuexData = this.$store.state.indicadorPrazos;

        return {
          id: this.$route.params.id ? this.$route.params.id : null,
          titulo: vuexData.titulo,
          obras: vuexData.obras,
          saneamento_voc_id: vuexData.saneamentoVoc?.id,
          data_imobilizacao_inicio: vuexData.dataImobilizacaoInicio,
          data_imobilizacao_fim: vuexData.dataImobilizacaoFim
        };
      }
    },

    watch: {}
  };
</script>
